import { IRequirementDefinitionCreateRequest } from "@wingspanhq/payments/dist/interfaces";

import { createRequirementDefinition } from "../../../services/requirementDefinitions/createRequirementDefinition";
import { useWSMutation } from "../../helpers";
import {
  QUERY_REQUIREMENT_DEFINITIONS_LIST,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_ALL
} from "../keys";
import { QUERY_EXTENDED_REQUIREMENT_DEFINITIONS } from "../query/useQueryExtendedRequirementDefinitions";
import { REQUIREMENTS_DEPENDENCIES } from "../../../modules/Requirements/dependencies";

export const useMutationCreateRequirementDefinition = () =>
  useWSMutation(
    (payload: IRequirementDefinitionCreateRequest) =>
      createRequirementDefinition(payload),
    {
      dependencies: [
        QUERY_REQUIREMENT_DEFINITIONS_LIST,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_ALL,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
        ...REQUIREMENTS_DEPENDENCIES
      ]
    }
  );
